import React from 'react'
import { useTranslation } from 'next-i18next'

const PROGRAM_SYLLABUS_MAP = {
  'front-end': 'Front_End_Syllabus_Peerstack.pdf',
  'back-end': 'Back_End_Syllabus_Peerstack.pdf',
  'full-stack': 'Full_Stack_Syllabus_Peerstack.pdf',
  'software-engineering': 'Software_Engineer_Syllabus_Peerstack.pdf',
}

const CheckSyllabus = ({ program }) => {
  const { t } = useTranslation()
  const filename = PROGRAM_SYLLABUS_MAP[program]

  const handleDownloadSyllabus = () => {
    if (!filename) return
    const link = document.createElement('a')
    link.href = `/syllabus/${filename}`
    link.download = filename
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className="w-full max-w-[90%] mx-auto py-[80px] md:py-[100px]">
      <div className="flex flex-col md:text-left text-center">
        <h2 className="text-[32px] md:text-[48px] font-[500] mb-[12px] md:mb-[20px] leading-tight">
          <span className="text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
            <span dangerouslySetInnerHTML={{ __html: t('programs-page.hero-slide-down-upmainform-title1') }} />
          </span>
        </h2>
        <p className="text-[16px] lg:text-[20px] font-[400] text-gray-700 mb-[32px] md:mb-[40px] leading-relaxed">
          {t('programs-page.hero-slide-down-upmainform-subtitle')}
        </p>
        <button
          type="button"
          onClick={handleDownloadSyllabus}
          className="w-[340px] h-[64px] bg-[#F5F7F9] text-[#091F59] underline underline-offset-4 text-[20px] font-[600] rounded-[12px] flex items-center justify-center hover:bg-[#091F59] hover:text-white transition-all duration-300 mx-auto"
        >
          {t('programs-page.hero-slide-down-upmainform-subtitle-button')}
        </button>
      </div>
    </div>
  )
}

export default CheckSyllabus